module.exports = __webpack_public_path__ + "static/media/test17_6.b879f9a1.png";